"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlParam = exports.getUrlParams = void 0;

var _getWindowObject = require("./get-window-object");

var getUrlParams = function getUrlParams() {
  var location = (0, _getWindowObject.getWindowObject)('location');

  if (!(location === null || location === void 0 ? void 0 : location.href)) {
    return new URLSearchParams('');
  }

  var url = new URL(location.href);
  return new URLSearchParams(url === null || url === void 0 ? void 0 : url.search);
};

exports.getUrlParams = getUrlParams;

var getUrlParam = function getUrlParam(paramName) {
  return getUrlParams().get(paramName);
};

exports.getUrlParam = getUrlParam;
//# sourceMappingURL=get-url-params.js.map